import moment from "moment";

export const CATEGORY_OPTIONS = {
  ALL: "All",
  UNCATEGORIZED: "Uncategorized",
};

export const REPORT_TYPES = {
  PROC: "proc-reports",
  PIVOT: "pivot-reports",
  CUBE: "cube-reports"
};

export const GLOBAL_KEYS = {
  TYPES: "types",
  SERIALIZED: "serialized",
  FOR_PIVOT: "for_pivot",
  SERIALIZED_HEADERS: "serialized_headers",
  PIVOT_EXPORT: "pivot_export",
  PIVOT_CONFIG: "pivot_config",
  FOR_SECOND_SPREADSHEET: "for_second_spreadsheet",
  FINAL_SERIALIZED: "final_serialized",
  DIMENSION_FOR_SECOND_SPREADSHEET: "dimension_for_second_spreadsheet",
  MASTER_ROW_FOR_SECOND_SPREADSHEET: "master_row_for_second_spreadsheet",
  PREVIEW_FIRST: "Preview_first",
  PREVIEW_SECOND: "Preview_second",
  OUTLIERS_FIRST_SPREADSHEET: "outliers_first_spreadsheet",
  OUTLIERS_SECOND_SPREADSHEET: "outliers_second_spreadsheet",
  PIVOT_FILTERS: "pivot_filters",
  ACTIVE_TYPE: "active_type",
  CONFIG: "config",
  CUSTOM_SOURCE_ID: "custom_source_id",
};

// export const reportDataMapper = {
//   Staff: ["no_Prepaidference", "employee_name", "employee_id"],
//   Service: ["item_id", "item_name", "service_at", "checkout_at"],
//   Products: ["item_id", "item_name", "quantity"],
//   Prepaid: [],
//   Campaigns: [],
//   Payment: [
//     "creditamount",
//     "cashamount",
//     "sales_after_discount",
//     "sales_before_discount",
//   ],
//   Client: [],
//   Appointment: [],
//   Loyalty: ["giftcardname", "giftcardtype", "giftcardtypenum"],
//   "Day of transaction": [],
//   "Time of transaction": [],
// };

export const getNthExcelCell = (n) => {
  let number = +n;
  if (!number || number <= 0) return "";
  let result = "";
  while (number > 0) {
    const remainder = (number - 1) % 26; // Adjust for 1-based indexing
    result = String.fromCharCode(97 + remainder) + result; // 97 is ASCII code for 'a'
    number = Math.floor((number - 1) / 26);
  }
  return result;
};

export const convertExcelCellToNumber = (x) => {
  const str = x?.toLowerCase?.() || "";
  let result = 0;
  for (let i = 0; i < str.length; i += 1) {
    const charCode = str.charCodeAt(i) - 96; // 96 is ASCII code for 'a'
    result = result * 26 + charCode;
  }
  return result;
};

export const alphabet = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "aa",
  "ab",
  "ac",
  "ad",
  "ae",
  "af",
  "ag",
  "ah",
  "ai",
  "aj",
  "ak",
  "al",
  "am",
  "an",
  "ao",
  "ap",
  "aq",
  "ar",
  "as",
  "at",
  "au",
  "av",
  "aw",
  "ax",
  "ay",
  "az",
];

// export const config = {
//   Staff: {
//     source: "transcation",
//     params: [
//       {
//         id: "no_Prepaidference",
//         type: null,
//         label: "Staff Selection",
//         transformType: "map",
//         mapper: [{ name: "Any", value: 1 }],
//         defaultMapper: "Postpaid",
//         hidden: true,
//       },
//       {
//         id: "employee_name",
//         type: null,
//         label: "Staff Name",
//       },
//       {
//         id: "employee_id",
//         type: null,
//         label: "Staff ID",
//       },
//     ],
//   },
//   Service: {
//     source: "transaction",
//     params: [
//       {
//         id: "item_id",
//         type: null,
//         label: "Item ID",
//       },
//       {
//         id: "item_name",
//         type: null,
//         label: "Item Name",
//       },
//       {
//         id: "service_at",
//         type: null,
//         label: "Service Time",
//         transform: "utcDatetimeToLocal",
//         format: "%Y-%m-%d %H:%i:%s",
//       },
//       {
//         id: "checkout_at",
//         type: null,
//         label: "Checkout Time",
//         transform: "utcDatetimeToLocal",
//         format: "%Y-%m-%d %H:%i:%s",
//       },
//     ],
//   },
//   Loyalty: {
//     source: "transaction",
//     params: [
//       {
//         id: "giftcardname",
//         label: "Prepaid Item",
//         type: null,
//       },
//       {
//         id: "giftcardtypenum",
//         label: "Prepaid Type#",
//         type: null,
//       },
//       {
//         id: "giftcardtype",
//         label: "Prepaid Type",
//         type: null,
//       },
//     ],
//   },
//   Products: {
//     source: "transaction",
//     params: [],
//   },
//   Prepaid: {
//     source: "transaction",
//     params: [],
//   },
//   Campaigns: {
//     source: "transaction",
//     params: [],
//   },
//   Payment: {
//     source: "transaction",
//     params: [],
//   },
//   Client: {
//     source: "transaction",
//     params: [],
//   },
//   Appointment: {
//     source: "transaction",
//     params: [],
//   },
//   "Day of transaction": {
//     source: "transaction",
//     params: [],
//   },
//   "Time of transaction": {
//     source: "transaction",
//     params: [],
//   },
// };

export const TYPES = {
  NA: "N/A",
  TXN: "Transaction",
  ITM: "Item",
  PRE: "Prepaid",
  APPT: "Appointment",
  CUSTOM: "Custom",
};

export const subFieldHelper = {
  "Hour Of Day": (v) => moment(v).format("HH A"),
  Date: (v) => moment(v).format("YYYY-MM-DD"),
};

// export const config = {
//   Staff: {
//     source: "transaction",
//     params: [
//       {
//         id: "no_preference",
//         label: "Staff Selection",
//         transform: "map",
//         mapper: [{ name: "Any", value: 1 }],
//         defaultMapper: "Postpaid",
//         hidden: true,
//         type: "N/A",
//       },
//       {
//         id: "employee_name",
//         type: "N/A",
//         label: "Staff Name",
//       },
//       {
//         id: "employee_id",
//         type: "N/A",
//         label: "Staff ID",
//       },
//     ],
//   },
//   Service: {
//     source: "transaction",
//     params: [
//       {
//         id: "item_id",
//         type: "N/A",
//         label: "Item ID",
//       },
//       {
//         id: "item_name",
//         type: "N/A",
//         label: "Item Name",
//       },
//       {
//         id: "service_at",
//         type: "N/A",
//         label: "Service Time",
//         transform: "utcDatetimeToLocal",
//         format: "%Y-%m-%d %H:%i:%s",
//       },
//       {
//         id: "checkout_at",
//         type: "Item",
//         label: "Checkout Time",
//         transform: "utcDatetimeToLocal",
//         format: "%Y-%m-%d %H:%i:%s",
//       },
//     ],
//   },
//   Loyalty: {
//     source: "transaction",
//     params: [
//       {
//         id: "giftcardname",
//         type: "N/A",
//         label: "Prepaid Item",
//       },
//       {
//         id: "giftcardtypenum",
//         type: "Transaction",
//         label: "Prepaid Type#",
//       },
//       {
//         id: "giftcardtype",
//         type: "Transaction",
//         label: "Prepaid Type",
//       },
//     ],
//   },
//   Products: {
//     source: "transaction",
//     params: [],
//   },
//   Prepaid: {
//     source: "transaction",
//     params: [],
//   },
//   Campaigns: {
//     source: "transaction",
//     params: [],
//   },
//   Payment: {
//     source: "transaction",
//     params: [],
//   },
//   Client: {
//     source: "transaction",
//     params: [],
//   },
//   Appointment: {
//     source: "appointment",
//     params: [],
//   },
//   "Day of Transaction": {
//     source: "transaction",
//     params: [],
//   },
//   "Time of Transaction": {
//     source: "transaction",
//     params: [],
//   },
// };
